const rawModules = import.meta.glob<string>('./articles/*.md', {
  eager: true,
  query: '?raw',
  import: 'default',
});

interface ArticleMeta {
  slug: string;
  title: string;
  date: string;
  content: string;
}

function extractTitle(text: string): string {
  for (const line of text.split('\n')) {
    if (line.startsWith('# ')) return line.slice(2).trim();
  }
  return '';
}

function parseDate(filename: string): string {
  const m = filename.match(/^(\d{2})(\d{2})(\d{2})/);
  return m ? `20${m[1]}-${m[2]}-${m[3]}` : '';
}

const articles: ArticleMeta[] = Object.entries(rawModules)
  .map(([path, mod]) => {
    const slug = path.replace(/^\.\/articles\/(.+)\.md$/, '$1');
    const content = typeof mod === 'string' ? mod : (mod as { default: string }).default;
    return { slug, title: extractTitle(content), date: parseDate(slug), content };
  })
  .sort((a, b) => b.date.localeCompare(a.date));

export default articles;
